(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-renew-magazineTop"] && !window.DesignMode) return;
  try {
    

  const params = new URLSearchParams(window.location.search);
  
  // デバッグ情報
  console.log("magazineMng:", magazineMng);
  console.log("URL params:", params.toString());
  
  setTimeout(function() {
    // 検索の場合
    if (params.get("search") != "" && params.get("search") != null) {
      document.getElementById("subtitle").innerText = params.get("search");
      document.getElementById("subtext").innerText = "検索キーワード";
      showSubDiv();
    } else {
      // カテゴリーまたはタグの場合、microCMSから動的に取得
      if (magazineMng.type == "category" || magazineMng.type == "tag") {
        loadTitleFromMicroCMS();
      } else {
        showMainDiv();
      }
    }
  }, 500);

  // microCMSからタイトルを取得する関数
  function loadTitleFromMicroCMS() {
    let endpoint;
    if (magazineMng.type == "category") {
      endpoint = "magazine_category";
    } else if (magazineMng.type == "tag") {
      endpoint = "magazine_tag";
    }
    
    console.log("API呼び出し:", endpoint, magazineMng.id);
    
    // clientが定義されているかチェック
    if (typeof client === 'undefined') {
      console.error("microCMS clientが定義されていません");
      showMainDiv();
      return;
    }
    
    client
      .get({
        endpoint: endpoint,
        contentId: magazineMng.id,
      })
      .then((res) => {
        console.log("API応答:", res);
        if (res) {
          const titleElement = document.getElementById("subtitle");
          const textElement = document.getElementById("subtext");
          
          if (magazineMng.type == "category") {
            // カテゴリーの場合
            titleElement.innerText = res.name;
            textElement.innerText = res.description || "カテゴリー";
          } else if (magazineMng.type == "tag") {
            // タグの場合
            titleElement.innerText = "#" + res.name;
            textElement.innerText = "サブカテゴリ";
          }
          
          showSubDiv();
        } else {
          console.error("API応答が空です");
          showMainDiv();
        }
      })
      .catch((error) => {
        console.error("タイトル取得エラー:", error);
        console.error("エラー詳細:", {
          type: magazineMng.type,
          id: magazineMng.id,
          endpoint: endpoint
        });
        showMainDiv();
      });
  }

  // サブタイトル表示
  function showSubDiv() {
    document.getElementById("subdiv").style.display = "block";
    document.getElementById("maindiv").style.display = "none";
    document.getElementById("newarticle").style.display = "none";
  }

  // メインタイトル表示
  function showMainDiv() {
    document.getElementById("subdiv").style.display = "none";
    document.getElementById("maindiv").style.display = "block";
    document.getElementById("newarticle").style.display = "block";
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-media-awards"]) return;
  try {
    
  let awards_slide_cd, awards_slide_c;
  $(function(){
    awards_slide_cd = $("#js-awards-slide-cd").slick({
      arrows: false,
      dots: true,
      infinite: false,
    });
    awards_slide_c = $("#js-awards-slide-c").slick({
      arrows: false,
      dots: true,
      infinite: false,
    });
    awards_slide_c.on("afterChange", function(slick, currentSlide) {
      var idx = currentSlide.currentSlide;
      $(".js-awards-slide-nav-c .year-item").removeClass("active");
      $(".js-awards-slide-nav-c .year-item").eq(idx).addClass("active");
    });
    awards_slide_cd.on("afterChange", function(slick, currentSlide) {
      var idx = currentSlide.currentSlide;
      $(".js-awards-slide-nav-cd .year-item").removeClass("active");
      $(".js-awards-slide-nav-cd .year-item").eq(idx).addClass("active");
    });
    $(".js-awards-slide-nav-c .year-item").on("click", function(){
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      awards_slide_c.slick('slickGoTo', $(".js-awards-slide-nav-c .year-item").index($(this)));
    });
    $(".js-awards-slide-nav-cd .year-item").on("click", function(){
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      awards_slide_cd.slick('slickGoTo', $(".js-awards-slide-nav-cd .year-item").index($(this)));
    });
    intersectAction($('.js-fadeUp, .js-fadeInLeft'), function (element, isIntersecting) {
      if (isIntersecting) {
        element.addClass('isShow')
      }
    });
    $('.js-awards-slide-nav-c .year-item:first-child').addClass('active');
    $('.js-awards-slide-nav-cd .year-item:first-child').addClass('active');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renew-c-lineup"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      $('.lineup-list').slick({
        arrows: false,
        centerMode: false,
        centerPadding: '50px',
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        autoplay: false,
        dots: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: { slidesToShow: 2, slidesToScroll: 1 },
          },
          {
            breakpoint: 640,
            settings: { slidesToShow: 1, slidesToScroll: 1 },
          },
        ],
      });
    }, 300); // DOM完成後に初期化
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renew-c-magazine"] && !window.DesignMode) return;
  try {
    
    //microCMSからデータ読み込み
    const LINK_BASE = '/pages/magazine/';
    const container = document.getElementById('magazine-list');

    function formatDate(dateString) {
        const date = new Date(dateString);
        const y = date.getFullYear();
        const m = ('0' + (date.getMonth() + 1)).slice(-2);
        const d = ('0' + date.getDate()).slice(-2);
        return `${y}.${m}.${d}`;
    }

    async function fetchLatestArticles() {
        try {
            // magazine.jsで定義されたclientを使用
            const res = await client.get({
                endpoint: "magazine",
                queries: { orders: "-publish_date", limit: 3 }
            });

            if (res.contents) {
                res.contents.forEach(content => {
                    const formattedDate = formatDate(content.publish_date);

                    const articleHTML = `
                        <a href="${LINK_BASE}${content.id}" class="magazine-item">
                            <div class="magazine-thumb">
                                <img src="${content.main_image ? content.main_image.url : ''}" alt="${content.main_image ? content.main_image.alt : ''}">
                            </div>
                            <p class="magazine-ttl">${content.title}</p>
                            <p class="magazine-date itc">${formattedDate}</p>
                        </a>
                    `;

                    container.insertAdjacentHTML('beforeend', articleHTML);
                });
            }
        } catch (error) {
            console.error('記事の取得に失敗しました:', error);
        }
    }

    function initMagazineSlick() {
        if ($(window).width() < 1024) {
            if (!$('.magazine-new-list').hasClass('slick-initialized')){
                $('.magazine-new-list').slick({
                    arrows: false,
                    infinite: true,
                    centerMode: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    autoplay: true,
                    speed: 2000,
                    responsive: [
                        {
                            breakpoint: 640,
                            settings: {
                                slidesToShow: 1,
                            },
                        },
                    ],
                });
            }
        }else{
            if ($('.magazine-new-list').hasClass('slick-initialized')){
                $('.magazine-new-list').slick('unslick');
            }
        }
    }

    $(document).ready(function(){
        fetchLatestArticles().then(() => {
            setTimeout(function() {
                initMagazineSlick();
            }, 300);

            $(window).on('resize', function(){
                setTimeout(function() {
                    initMagazineSlick();
                }, 300);
            });
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renew-mypageTop-banner"]) return;
  try {
    
    $(document).ready(function(){
        $('.banner-list').slick({
            arrows: false,
            dots: true,
            customPaging: function(slider, i) {
                  return '<button class="slick-dot"></button>'; // 数字ではなくドットを表示
            },
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false,
            autoplay: false,
            speed: 2000,
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 1,
                      variableWidth: true,
                    },
                },
                {
                    breakpoint: 641,
                    settings: {
                        slidesToShow: 1,
                        variableWidth: false,
                    },
                },
            ],
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renew-mypageTop-new"] && !window.DesignMode) return;
  try {
    
    //microCMSからデータ読み込み
    const LINK_BASE = '/pages/magazine/';
    const container = document.getElementById('magazine-list');

    function formatDate(dateString) {
        const date = new Date(dateString);
        const y = date.getFullYear();
        const m = ('0' + (date.getMonth() + 1)).slice(-2);
        const d = ('0' + date.getDate()).slice(-2);
        return `${y}.${m}.${d}`;
    }

    async function fetchLatestArticles() {
        try {
            // magazine.jsで定義されたclientを使用
            const res = await client.get({
                endpoint: "magazine",
                queries: { orders: "-publish_date", limit: 2 }
            });

            if (res.contents) {
                res.contents.forEach(content => {
                    const formattedDate = formatDate(content.publish_date);

                    const articleHTML = `
                        <a href="${LINK_BASE}${content.id}" class="magazine-item">
                            <div class="magazine-thumb">
                                <img src="${content.main_image ? content.main_image.url : ''}" alt="${content.main_image ? content.main_image.alt : ''}" >
                            </div>
                            <div class="magazine-txt">
                                <p class="magazine-ttl">${content.title}</p>
                                <p class="magazine-date itc">${formattedDate}</p>
                            </div>
                        </a>
                    `;

                    container.insertAdjacentHTML('beforeend', articleHTML);
                });
            }
        } catch (error) {
            console.error('記事の取得に失敗しました:', error);
        }
    }

    // ページ読み込み時に記事を取得
    fetchLatestArticles();

    //slick初期化
  $(document).ready(function(){
    function initSlick() {
        if($(window).width() < 1024) {
            if (!$('.magazine-list').hasClass('slick-initialized')){
                $('.magazine-list').slick({
                    arrows: false,
                    infinite: false,
                    slidesToShow: 2,
                    autoplay: true,
                    speed: 2000,
                    responsive: [
                        {
                            breakpoint: 641,
                            settings: {
                                slidesToShow: 1,
                            },
                        },
                    ],
                });
            }
        } else {
            if ($('.magazine-list').hasClass('slick-initialized')){
                $('.magazine-list').slick('unslick');
            }
        }
    }
    initSlick();

    $(window).on('resize', function(){
        initSlick();
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renew-top-action"]) return;
  try {
    
//slick初期化
$(document).ready(function(){
    function initActionSlick() {
        if ($(window).width() < 1024) {
            if (!$('.action-list').hasClass('slick-initialized')){
                $('.action-list').slick({
                    arrows: false,
                    infinite: true,
                    centerMode: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    autoplay: true,
                    speed: 2000,
                    responsive: [
                        {
                            breakpoint: 640,
                            settings: {
                                slidesToShow: 1,
                            },
                        },
                    ],
                });
            }
        }else{
            if ($('.action-list').hasClass('slick-initialized')){
                $('.action-list').slick('unslick');
            }
        }
    }

    setTimeout(function() {
        initActionSlick();
    }, 300);

    $(window).on('resize', function(){
        setTimeout(function() {
            initActionSlick();
        }, 300);
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renew-top-kv"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
      $('.kv-list').slick({
          arrows: false,
          dots: true,
          customPaging: function(slider, i) {
                  return '<button class="slick-dot"></button>'; // 数字ではなくドットを表示
          },
          autoplay: true,
          speed: 2000,
          pauseOnFocus: false,
          pauseOnHover: false,
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renew-top-magazine"] && !window.DesignMode) return;
  try {
    
          $(document).ready(function(){
            function initSlick() {
                if($(window).width() < 1024) {
                    if (!$('.magazine-list').hasClass('slick-initialized')){
                        $('.magazine-list').slick({
                            arrows: false,
                            infinite: false,
                            slidesToShow: 2,
                            autoplay: true,
                            speed: 2000,
                            responsive: [
                                {
                                    breakpoint: 641,
                                    settings: {
                                        slidesToShow: 1,
                                    },
                                },
                            ],
                        });
                    }
                } else {
                    if ($('.magazine-list').hasClass('slick-initialized')){
                        $('.magazine-list').slick('unslick');
                    }
                }
            }
            initSlick();

            $(window).on('resize', function(){
                initSlick();
            });
        });
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renew-top-report"] && !window.DesignMode) return;
  try {
    
    const LINK_BASE = "/pages/magazine/";
    const items = document.querySelectorAll('.report-item');

    items.forEach(async (item) => {
      const entryId = item.dataset.entryId;

      try {
          const res = await client.get({
              endpoint: "magazine",
              contentId: entryId
          });

          item.href = LINK_BASE + entryId;

          const title = item.querySelector('.report-ttl');
          title.textContent = res.title;

          const imgContainer = item.querySelector('.img-con');
          imgContainer.innerHTML = `<img src="${res.main_image ? res.main_image.url : ''}" alt="${res.main_image ? res.main_image.alt : ''}">`;

      } catch (error) {
          console.error('Error loading content for ID:', entryId, error);
          // エラー時でもデフォルトのhrefを設定
          item.href = LINK_BASE + entryId;
      }
    });

    // aタグのクリックイベントを明示的に処理
    // $(document).on('click', '.report-item', function(e) {
    //   const href = $(this).attr('href');
    //   if (href && href !== '#') {
    //     window.location.href = href;
    //   }
    // });

    $(document).ready(function() {
      function initReportSlick() {
        if ($(window).width() < 1024) {
          if (!$('.report-list').hasClass('slick-initialized')){
            $('.report-list').slick({
              arrows: false,
              infinite: true,
              centerMode: true,
              centerPadding: '50px',
              slidesToShow: 2,
              slidesToScroll: 1,
              autoplay: true,
              speed: 2000,
              clickToSlide: true,
              responsive: [
                  {
                  breakpoint: 640,
                  settings: {
                      slidesToShow: 1
                  }
                  }
              ]
            });
          }
        }else{
          if ($('.report-list').hasClass('slick-initialized')){
            $('.report-list').slick('unslick');
          }
        }
    }

    setTimeout(function() {
      initReportSlick();
    }, 300);

    $(window).on('resize', function(){
      initReportSlick();
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !window.DesignMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();
})();
